import { CIcon } from '~/icons/types'
export const ciSearchCategories: CIcon = {
  name: 'search-categories',
  type: 'solid',
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M8 1H4a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3ZM8 13H4a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3ZM20 1h-4a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h4a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3ZM21.406 19.993a4.553 4.553 0 1 0-1.414 1.414l1.3 1.3a1 1 0 0 0 1.414-1.414l-1.3-1.3Zm-2.044-.631a2.527 2.527 0 0 1-1.8.749 2.556 2.556 0 1 1 2.36-1.576c-.13.31-.32.591-.56.827Z'
    }
  ]
}
